import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { getCurrentUserRoles } from '../../../app/shared/functions/shared-functions';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  items = this.navigationService.items;

  constructor(private navigationService: NavigationService) {}

  ngOnInit() {}
}
